import { render, staticRenderFns } from "./RoutingSettings.vue?vue&type=template&id=5c154f14&scoped=true&"
import script from "./RoutingSettings.vue?vue&type=script&lang=js&"
export * from "./RoutingSettings.vue?vue&type=script&lang=js&"
import style0 from "./RoutingSettings.vue?vue&type=style&index=0&id=5c154f14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c154f14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c154f14')) {
      api.createRecord('5c154f14', component.options)
    } else {
      api.reload('5c154f14', component.options)
    }
    module.hot.accept("./RoutingSettings.vue?vue&type=template&id=5c154f14&scoped=true&", function () {
      api.rerender('5c154f14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/BatchStop/Settings/RoutingSettings.vue"
export default component.exports